import React, {Component} from 'react';

export default class About extends Component {

    render() {
        return (
            <div className="page">
                <div className="page_contents">
                    <h1>{'About'}</h1>
                    <div className="card">
                        <p>
                            <strong>{'Deep Contrast Inc'}</strong>{` is a startup that develops neuromorphic
                            image processing technologies.`}
                        </p>

                        <p>{`Our first product is a brain-inspired image enhancement system that automatically boosts the clarity and vividness of
                            images,
                            maximizing their communicative value. Processed images often appear "as if a veil was lifted", or as if someone "turned
                            the
                            lights on brighter". We like to say our product makes images "pop".`}</p>
                        <p>
                            {`Popping requires extreme computation – on the order of a million operations per pixel. Most of the work is devoted to
                            figuring
                            out where, and where not, to act. In the end, only a small fraction of the pixels in an image are modified – but those
                            that
                            are most important for recognizing what the image contains.`}
                        </p>
                        <p>
                            {`Popped image look great on computer screens, smartphones,
                            and printed on paper.`}
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/About.js